<template>
  <div class="globalAudio">
    <audio :src="IMAGE.systemTipVoice.clickVoice" style="display: block" class="clickVoice" id="clickVoice"></audio>
    <audio :src="IMAGE.systemTipVoice.successVoice" style="display: block" class="successVoice" id="successVoice"></audio>
    <audio :src="IMAGE.systemTipVoice.selectFoodVoice" style="display: block" class="selectFoodVoice" id="selectFoodVoice"></audio>
    <audio :src="IMAGE.systemTipVoice.thanksVoice" style="display: block" class="thanksVoice" id="thanksVoice"></audio>
  </div>
</template>
<script>
  import srcMixins from '@/mixins/srcMixins.js'
  export default {
    name: 'globalAudio',
    mixins:[srcMixins],
    data() {
      return{

      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/audio/globalAudio.vue